import React from 'react';
import { tv } from 'tailwind-variants';
import ButtonWrapper from 'helpers/SitecoreWrappers/ButtonWrapper/ButtonWrapper';
import { useUIText } from '../../hooks/useUIText';

interface SectionCardActionsProps {
  cardId?: string;
  onAdd?: () => void;
  onStart?: () => void;
  cardTitle?: string;
  showAdd?: boolean;
  showStart?: boolean;
  isCTAEnabled?: boolean;
  startCTAText?: string;
}

export const SectionCardActions: React.FC<SectionCardActionsProps> = ({
  cardId,
  onAdd,
  onStart,
  cardTitle,
  showAdd = false,
  showStart = false,
  isCTAEnabled = true,
  startCTAText,
}) => {
  const { getButtonText, getActionText } = useUIText();
  const { addButtonContainer, startButtonContainer } = TAILWIND_VARIANTS();

  return (
    <>
      {showAdd && onAdd && (
        <div className={addButtonContainer()}>
          <ButtonWrapper
            type="button"
            text={getButtonText('add', 'Add')}
            ctaComponentClass="default"
            ctaVariant="primary"
            onClick={onAdd}
            disabled={!isCTAEnabled}
            className="w-fit"
          />
        </div>
      )}

      {showStart && onStart && (
        <div id={cardId} className={startButtonContainer()} data-testid="start-button">
          <ButtonWrapper
            type="button"
            text={
              startCTAText ||
              getActionText('startSectionTemplate', `Start ${cardTitle || 'this section'}`, {
                cardTitle: cardTitle || 'this section',
              })
            }
            ctaComponentClass="default"
            ctaVariant="primary"
            onClick={onStart}
            disabled={!isCTAEnabled}
            className="w-fit"
          />
        </div>
      )}
    </>
  );
};

const TAILWIND_VARIANTS = tv({
  slots: {
    addButtonContainer: [
      'flex',
      'flex-row',
      'justify-center',
      'pt-spacing-spacing-8',
      'border-t',
      'border-gray-200',
    ],
    startButtonContainer: [
      'w-full',
      'p-padding-base',
      'flex',
      'flex-row',
      'justify-center',
      'border',
      'border-dashed',
      'border-color-core-color-1-Navy',
    ],
  },
});
